import { defineComponent as _defineComponent } from 'vue'
import { getdetail, getcomment } from "@/api";
import { watchEffect, ref } from "../../../../adapter-vue";
import {
  TUITranslateService,
  IMessageModel,
} from "@tencentcloud/chat-uikit-engine";
import { isUrl, JSONToObject } from "../../../../utils/index";
import { CHAT_MSG_CUSTOM_TYPE } from "../../../../constant";
import { ICustomMessagePayload } from "../../../../interface";
import Icon from "../../../common/Icon.vue";
import star from "../../../../assets/icon/star-light.png";
import Dialog from "../../../common/Dialog/index.vue";
import { isPC } from "../../../../utils/env";
import flowList from "@/components/flowList.vue";
import formcontent from "@/components/formcontent.vue";
import logcomment from "@/components/logcomment.vue";
import logform from "@/components/logform.vue";
import Comment from "@/components/Comment.vue";
import Deal from "@/components/deal.vue";
import SendBack from "@/components/sendBack.vue";
import TurnOver from "@/components/turnOver.vue";
import prints from "@/components/print.vue";
import share from "@/components/share.vue";
import { durationLabelComponent } from '@/views/approve/sponsor/components/const.js'
interface Props {
  messageItem: IMessageModel;
  content: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'message-custom',
  props: {
    messageItem: { default: undefined },
    content: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { messageItem: IMessageModel, content: any }

const comment = ref<InstanceType<typeof Comment> | null>(null);
const deal = ref<InstanceType<typeof Deal> | null>(null);
const sendBack = ref<InstanceType<typeof SendBack> | null>(null);
const turnOver = ref<InstanceType<typeof TurnOver> | null>(null);



const custom = ref();
const isflow = ref(false);
const flow_list = ref<any[]>([]);
const dataInfo = ref<any>({});
const form_config = ref<any>([]);
const stepsActive = ref(1);
const dialogVisible = ref(false);
const visible = ref(false);
const message = ref<IMessageModel>();
const extension = ref();
const logcontent = ref([]);
const commentdata = ref({});
const customData = ref<ICustomMessagePayload>({
  businessID: "",
});
const status = ref(1);
const title = ref("");
const person_type = ref(0);

const log = ref<HTMLElement>();
watchEffect(() => {
  custom.value = props.content;
  message.value = props.messageItem;
  const { payload } = props.messageItem;
  customData.value = payload.data || "";
  customData.value = JSONToObject(payload.data);
  if (payload.data === CHAT_MSG_CUSTOM_TYPE.SERVICE) {
    extension.value = JSONToObject(payload.extension);
  }
});
const hanldialogVisible = (id) => {
  getdetail({ id }).then((res) => {
    let flow = res.data.flow_list || [];
    flow_list.value = flow.map((item) => {
      let processor = item.processor
        ? item.processor
            .split(",")
            .filter((i) => i)
            .map((i) => i * 1)
        : "";
      let employees = Array.isArray(item.employees) ? item.employees : [];
      return {
        ...item,
        employees:
          processor && item.person_type == 4
            ? employees.filter((v) => processor.indexOf(v.id) > -1)
            : employees,
      };
    });
    person_type.value =
      flow_list.value[res.data.cur_flow_level - 1]?.person_type || 0;
    form_config.value = res.data.form_content.fields;
    //加入时长的显示
    let durationFieldRightIndex = form_config.value.findIndex(
              (i:any) => i.__config__.show_duration);
    if (durationFieldRightIndex > -1) {
              let durationObj = form_config.value[durationFieldRightIndex];
              let durationLabelComponent_ = durationLabelComponent;
              let danweiMap = {
                1: "小时",
                2: "天",
                3: "天",
              };
              let str = durationObj.__config__.duration;
              let danwei = danweiMap[durationObj.__config__.duration_type];
              let field = {
                ...durationLabelComponent_,
                __config__: {
                  ...durationLabelComponent_.__config__,
                  defaultValue: JSON.stringify(
                    `${str}${danwei}` ? `${str}${danwei}` : ""
                  ),
                },
              };
              form_config.value.splice(
                durationFieldRightIndex + 1,
                0,
                field
              );
            }
    //
    console.log(form_config.value,'form_config.value')
    stepsActive.value = res.data.cur_flow_level;
    dataInfo.value = res.data;
    let userid = localStorage.getItem("userid");
    let cur_flow = dataInfo.value.cur_flow;
    let employees = cur_flow.employees ? cur_flow.employees : [];
    isflow.value = employees.some((item) => {
      return item.id == userid && item.is_processed !== 1;
    });
    dialogVisible.value = true;
  });
};
const hanlVisible = (id) => {
  getcomment({ id })
    .then((res) => {
      commentdata.value = res.data;
      let form_content = res.data.form_content || res.data.form_config;
      let c = form_content ? JSON.parse(form_content) : [];
      let arr = c ? c.fields || c : [];
      logcontent.value = arr != null && arr.length > 0 ? arr : [];
      console.log(log.value);
      visible.value = true;
    })
    .then(() => {
      log.value?.scrollTo({ top: 9999999999 });
    });
};
const setlogcomment = (data) => {
  hanlVisible(commentdata.value?.id);
};
const toggleShow = (showStatus: boolean) => {
  dialogVisible.value = showStatus;
};

const toggleShow1 = (showStatus: boolean) => {
  visible.value = showStatus;
};
const openLink = (url: any) => {
  window.open(url);
};
const toStr = (data, key) => {
  return data[key];
};
const handturnOver = () => {
  let id = dataInfo.value.flow_list.filter((item) => item.flow_status == 1)[0]
    .id;
  let dom = turnOver.value;
  dom?.toggle(true);
  dom?.getDetail(dataInfo.value, id);
  dom = null;
};
const handsendBack = () => {
  let id = dataInfo.value.flow_list.filter((item) => item.flow_status == 1)[0]
    .id;
  let dom = sendBack.value;
  dom?.toggle(true);
  dom?.getDetail(dataInfo.value, id);
  dom = null;
};
const handledeal = (status1, title1) => {
  let id = dataInfo.value.flow_list.filter((item) => item.flow_status == 1)[0]
    .id;
  status.value = status1;
  title.value = title1;
  let dom = deal.value;
  dom?.toggle(true);
  dom?.getDetail(dataInfo.value, id);
  dom = null;
};
const handleComment = () => {
  let dom = comment.value;
  dom?.toggle(true);
  dom?.getDetail(dataInfo.value);
  dom = null;
};

return { __sfc: true,comment, deal, sendBack, turnOver, props, custom, isflow, flow_list, dataInfo, form_config, stepsActive, dialogVisible, visible, message, extension, logcontent, commentdata, customData, status, title, person_type, log, hanldialogVisible, hanlVisible, setlogcomment, toggleShow, toggleShow1, openLink, toStr, handturnOver, handsendBack, handledeal, handleComment, TUITranslateService, isUrl, CHAT_MSG_CUSTOM_TYPE, Icon, star, Dialog, isPC, flowList, formcontent, logcomment, logform, Comment, Deal, SendBack, TurnOver, prints, share }
}

})